var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ConnectionsListItemAdditionalInfo"},[_c('div',{staticClass:"ConnectionsListItemAdditionalInfo__row"},[_c('b',[_vm._v("Dane dodatkowe")]),_vm._v(": "+_vm._s(_vm.connection._another_action || '---')+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }